import { useMemo } from 'react';
import {
  getPDPCustomizerURLParams,
  getSelectionsObj,
} from 'components/consumer/PDP/helpers/pdpQueryParamUtils';
import { isEmpty } from 'lodash';

const usePDPInitialOptionsFromQueryParams = ({ productOptions, search }) => {
  const selectedOptionsUrlParams = useMemo(() => {
    if (!search) {
      return null;
    }

    // Create a location-like object with just the search property
    // getPDPCustomizerURLParams expects an object with a 'search' property
    return getPDPCustomizerURLParams({ search });
  }, [search]);

  const selectedOptionsFromURLOverride = useMemo(() => {
    if (!selectedOptionsUrlParams || !productOptions) {
      return null;
    }

    const urlSelections = getSelectionsObj(
      productOptions,
      selectedOptionsUrlParams
    );

    return !isEmpty(urlSelections) ? urlSelections : null;
  }, [productOptions, selectedOptionsUrlParams]);

  return selectedOptionsFromURLOverride;
};

export default usePDPInitialOptionsFromQueryParams;
